import React from 'react';
import { isLpgProductId } from '../../../../../../../../shared/offer-domain/constants';
import RequirementTabNonLpg from './nonLpg/RequirementTabNonLpg';
import RequirementTabLpg from './lpg/RequirementTabLpg';

const RequirementTab = props => {
  if (isLpgProductId(props.form?.productNameId)) {
    return <RequirementTabLpg {...props} />;
  }

  return <RequirementTabNonLpg {...props} />;
};

export default RequirementTab;
